module.exports = __webpack_public_path__ + "static/media/CLC_cover_07.cb5c188b.jpg";